import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  globalSearchDetails: null,
  error: null,
  count: 0,
};

const fetchStarting = (state) => {
  state.isLoad = true;
  state.error = null;
};

const fetchFailures = (state, action) => {
  state.isLoad = false;
  state.error = action.payload;
};

const fetchSuccessing = (state, action) => {
  state.isLoading = false;
  state.globalSearchDetails = action.payload;
  state.error = null;
  state.count = action.payload?.totalCount;
};

const fetchListStart = fetchStarting;
const fetchSuccess = fetchSuccessing;
const fetchListFailure = fetchFailures;

const globalSearchSlice = createSlice({
  name: "globalSearch",
  initialState,
  reducers: {
    fetchIsoMaterialGlobalSearchStart: fetchListStart,
    fetchIsoMaterialGloabalSearchSuccess: fetchSuccess,
    fetchIsoMaterialGloabalSearchFailure: fetchListFailure,

    fetchWeldingGasGlobalSearchStart: fetchListStart,
    fetchWeldingGasGloabalSearchSuccess: fetchSuccess,
    fetchWeldingGasGloabalSearchFailure: fetchListFailure,

    fetchMachineCertificationGlobalSearchStart: fetchListStart,
    fetchMachineCertificationGloabalSearchSuccess: fetchSuccess,
    fetchMachineCertificationGloabalSearchFailure: fetchListFailure,

    fetchWeldingOperatorsGlobalSearchStart: fetchListStart,
    fetchWeldingOperatorsGloabalSearchSuccess: fetchSuccess,
    fetchWeldingOperatorsGloabalSearchFailure: fetchListFailure,

    fetchIsoWeldLogGlobalSearchStart: fetchListStart,
    fetchIsoWeldLogGloabalSearchSuccess: fetchSuccess,
    fetchIsoWeldLogGloabalSearchFailure: fetchListFailure,

    resetGlobalSearchState: (state) => {
      state.globalSearchDetails = null;
      state.count = 0;
      state.error = null;
    },
  },
});

export const {
  fetchIsoMaterialGlobalSearchStart,
  fetchIsoMaterialGloabalSearchSuccess,
  fetchIsoMaterialGloabalSearchFailure,
  fetchWeldingGasGlobalSearchStart,
  fetchWeldingGasGloabalSearchSuccess,
  fetchWeldingGasGloabalSearchFailure,
  fetchMachineCertificationGlobalSearchStart,
  fetchMachineCertificationGloabalSearchSuccess,
  fetchMachineCertificationGloabalSearchFailure,
  fetchWeldingOperatorsGlobalSearchStart,
  fetchWeldingOperatorsGloabalSearchSuccess,
  fetchWeldingOperatorsGloabalSearchFailure,
  fetchIsoWeldLogGlobalSearchStart,
  fetchIsoWeldLogGloabalSearchSuccess,
  fetchIsoWeldLogGloabalSearchFailure,
  resetGlobalSearchState,
} = globalSearchSlice.actions;

export default globalSearchSlice.reducer;
